import {
  AVATAR_TINTS,
  SEGMENTS,
  type PatientSortBy,
  type PatientSortDir,
  type SegmentId,
} from "@/frontend/types/dashboard/patients";

/** Picks a stable tint from the row id so the same patient always looks the same. */
export function avatarTint(id: string): string {
  let hash = 0;
  for (let index = 0; index < id.length; index++) {
    hash = (hash * 31 + id.charCodeAt(index)) % AVATAR_TINTS.length;
  }
  return AVATAR_TINTS[hash] ?? AVATAR_TINTS[0] ?? "";
}

/** Narrows an unknown search value to a valid segment, dropping anything else. */
export function toSegment(value: unknown): SegmentId | undefined {
  return SEGMENTS.some((segment) => segment.id === value) ? (value as SegmentId) : undefined;
}

/** Narrows an unknown search value to a sortable column. */
export function toSortBy(value: unknown): PatientSortBy | undefined {
  return value === "lastActivity" || value === "name" || value === "records" ? value : undefined;
}

/** Narrows an unknown search value to a sort direction. */
export function toSortDir(value: unknown): PatientSortDir | undefined {
  return value === "asc" || value === "desc" ? value : undefined;
}

/**
 * Whether `ensureSelfPatient` refused because the workspace already holds a
 * patient that is not the caller's own.
 *
 * @param error whatever the call threw
 * @returns true for the CONFLICT that has a sane fallback
 */
export function isSelfPatientConflict(error: unknown): boolean {
  const code = (error as { code?: unknown } | null)?.code;
  return code === "CONFLICT";
}
